// Landing page: the server-authoritative trading game + the Three.js hero.
import { initGame } from '../game/game';
import { initHeroScene } from '../three/hero';

initHeroScene();
initGame();
